import { render, staticRenderFns } from "./ExamplePieCard.vue?vue&type=template&id=afbbf32a"
import script from "./ExamplePieCard.vue?vue&type=script&lang=js"
export * from "./ExamplePieCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afbbf32a')) {
      api.createRecord('afbbf32a', component.options)
    } else {
      api.reload('afbbf32a', component.options)
    }
    module.hot.accept("./ExamplePieCard.vue?vue&type=template&id=afbbf32a", function () {
      api.rerender('afbbf32a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Analytics/ExamplePieCard.vue"
export default component.exports